import { MAX_ITEMS_IN_PAGE } from "../../actions/commonActions";

const initState = {
  projects: [],
  projectTasks: [],
  project: {},
  projectTask: {},
  projectMembers: [], //project's members
  memberProjects: [], //member's project
  taskAssignee: {},
  taskAssignees: [],
  totalProjectHours: {},
  totalProjectCost: {},
  projectHoursWeek: {},
  projectsByRole: [],
  approvers: [],
  projPlatforms: [],
  projPlatformBands: [],
  projScoping: [],
  allProjScoping: [],
  costingTotals: [],
  taskDistributions: [],
  isModifyingCost: false,
  blendedRates: [],
  forApprovals: [],
  forApproval: {},
  requestBudgetHours: {},
  budgetedHours: [],
  projectFilter: {},
  currentPage: 1,
  totalPages: 0,
  numItems: 0,
  min: 1,
  max: MAX_ITEMS_IN_PAGE,
  numAttachments: 1,
  childrenProjects: [],
  clientProjects: [],
};

const projectsReducer = (state = initState, action) => {
  switch (action.type) {
    case "PROJECT_SET_FIELD_VALUE":
      return {
        ...state,
        project: Object.assign(state.project, action.value),
      };
    case "SET_PROJECT":
      return {
        ...state,
        project: action.project,
      };
    case "RESET_PROJECT":
      return {
        ...state,
        project: {},
        projectTasks: [],
        projectMembers: [],
        projScoping: [],
        taskDistributions: [],
        costingTotals: [],
        blendedRates: [],
      };
    case "CLEAR_PROJECTS":
      return {
        ...state,
        projects: [],
      };
    case "RESET_PLATFORM_BANDS":
      return {
        ...state,
        projPlatformBands: [],
      };
    case "FETCH_PROJECTS":
      return {
        ...state,
        projects: action.projects,
      };
    case "FETCH_PROJECT_MEMBERS":
      return {
        ...state,
        projectMembers: action.projectMembers,
      };
    case "RESET_PROJECT_MEMBERS":
      return {
        ...state,
        projectMembers: [],
      };
    case "ADD_PROJECT_MEMBER":
      return {
        ...state,
        projectMembers: [...state.projectMembers, action.projectMember],
      };
    case "FETCH_MEMBER_PROJECTS":
      return {
        ...state,
        memberProjects: action.memberProjects,
      };
    case "SET_PROJECT_TASK":
      return {
        ...state,
        projectTask: action.projectTask,
      };
    case "FETCH_PROJECT_TASKS":
      return {
        ...state,
        projectTasks: action.projectTasks,
      };
    case "SET_TASK_ASSIGNEE":
      return {
        ...state,
        taskAssignee: Object.assign(state.taskAssignee, action.value),
      };
    case "RESET_TASK_ASSIGNEE":
      return {
        ...state,
        taskAssignee: {},
      };
    case "UPDATE_TASK_ASSIGNMENT_HOURS":
      return {
        ...state,
        taskAssignees: state.taskAssignees.map((taskAssignee) =>
          taskAssignee.id === action.id
            ? { ...taskAssignee, hours: action.hours }
            : taskAssignee
        ),
      };
    case "FETCH_TASK_ASSIGNEES":
      return {
        ...state,
        taskAssignees: action.taskAssignees,
      };
    case "FETCH_TOTAL_HOURS_PER_PROJECT":
      return {
        ...state,
        totalProjectHours: Object.assign(state.totalProjectHours, {
          [action.projectId]: action.totalProjectHours,
        }),
      };
    case "FETCH_TOTAL_COST_PER_PROJECT":
      return {
        ...state,
        totalProjectCost: Object.assign(state.totalProjectCost, {
          [action.projectId]: action.totalProjectCost,
        }),
      };
    case "FETCH_PROJECT_HOURS_PER_WEEK":
      return {
        ...state,
        projectHoursWeek: Object.assign(state.projectHoursWeek, {
          [action.projectId]: action.projectHoursWeek,
        }),
      };
    case "FETCH_PROJECTS_BY_ROLE":
      return {
        ...state,
        projectsByRole: action.projectsByRole,
      };
    case "ADD_APPROVER":
      return {
        ...state,
        approvers: [...state.approvers, action.approver],
      };
    case "SET_APPROVERS":
      return {
        ...state,
        approvers: action.approvers,
      };
    case "RESET_APPROVERS":
      return {
        ...state,
        approvers: [],
      };
    case "SET_PROJECT_PLATFORMS":
      return {
        ...state,
        projPlatforms: action.projPlatforms,
      };
    case "SET_PROJECT_PLATFORMS_BANDS":
      return {
        ...state,
        projPlatformBands: action.projPlatformBands,
      };
    case "SET_PROJECT_SCOPING":
      return {
        ...state,
        projScoping: action.projScoping,
      };
    case "SET_COSTING_TOTALS":
      return {
        ...state,
        costingTotals: action.costingTotals,
      };
    case "RESET_COSTING_TOTALS":
      return {
        ...state,
        costingTotals: [],
      };
    case "SET_TASK_DISTRIBUTIONS":
      return {
        ...state,
        taskDistributions: action.taskDistributions,
      };
    case "RESET_TASK_DISTRIBUTION":
      return {
        ...state,
        taskDistributions: [],
      };
    case "UPDATE_PROJECT_PLATFORM_BAND":
      return {
        ...state,
        projPlatformBands: state.projPlatformBands.map((projPlatformBand) =>
          projPlatformBand.id === action.bandId
            ? {
                ...projPlatformBand,
                taskDistribution: action.taskDistribution,
                totalCostPerBand: action.totalCostPerBand,
                totalBandManHours: action.totalBandManHours,
              }
            : projPlatformBand
        ),
      };
    case "SET_IS_MODIFYING_COST":
      return {
        ...state,
        isModifyingCost: action.modifying,
      };
    case "SET_BLENDED_RATES":
      return {
        ...state,
        blendedRates: action.blendedRates,
      };
    case "ADD_BLENDED_RATES":
      return {
        ...state,
        blendedRates: [...state.blendedRates, action.blendedRate],
      };
    case "RESET_BLENDED_RATES":
      return {
        ...state,
        blendedRates: [],
      };
    case "FETCH_FOR_APPROVALS":
      return {
        ...state,
        forApprovals: action.forApprovals,
      };
    case "ADD_PROJECT_REJECT_REMARKS":
      return {
        ...state,
        projects: Object.assign(state.project, action.remarks),
      };
    case "SET_PROJECT_FOR_APPROVAL":
      return {
        ...state,
        forApproval: action.forApproval,
      };
    case "RESET_PROJECT_FOR_APPROVAL":
      return {
        ...state,
        forApproval: {},
      };
    case "RESET_PROJECT_HOURS_WEEK":
      return {
        ...state,
        projectHoursWeek: {},
      };
    case "RESET_TOTAL_PROJECT_HOURS":
      return {
        ...state,
        totalProjectHours: {},
      };
    case "SET_PROJECT_FILTER":
      return {
        ...state,
        projectFilter: action.projectFilter,
      };
    case "RESET_PROJECT_FILTER":
      return {
        ...state,
        projectFilter: {},
      };
    case "SET_PROJECT_SIEVE":
      return {
        ...state,
        projectSieve: action.projectSieve,
      };
    case "SET_PROJECTS_PAGINATION":
      return {
        ...state,
        numItems: action.numItems,
        min: action.min,
        totalPages: action.totalPages,
        currentPage:
          typeof action.currentPage !== "undefined"
            ? action.currentPage
            : state.currentPage,
        max: action.max,
      };
    case "RESET_PROJECTS_PAGINATION":
      return {
        ...state,
        currentPage: 1,
        totalPages: 0,
        numItems: 0,
        min: 1,
        max: MAX_ITEMS_IN_PAGE,
      };
    case "SET_NUM_ATTACHMENTS":
      return {
        ...state,
        numAttachments: action.numAttachments,
      };
    case "SET_PROJECT_ATTACHMENTS":
      return {
        ...state,
        project: Object.assign(state.project, {
          project_attachments: action.projectAttachments,
        }),
      };
    case "ADD_ALL_PROJECT_SCOPING":
      return {
        ...state,
        allProjScoping: [...state.allProjScoping, action.scope],
      };
    case "RESET_ALL_PROJECT_SCOPING":
      return {
        ...state,
        allProjScoping: [],
      };
    case "FETCH_CHILDREN_PROJECTS":
      return {
        ...state,
        childrenProjects: action.childrenProjects,
      };
    case "FETCH_CLIENT_PROJECTS":
      return {
        ...state,
        clientProjects: action.clientProjects,
      };
    case 'RESET_TASK_ASSIGNEE':
      return {
        ...state,
        taskAssignee: {
          member: null,
          selectedMember: null,
          hours: "",
          startDate: "",
          endDate: "",
          targetActivity: "",
        },
      };
    default:
      return state;
  }
};

export default projectsReducer;
